/** Public asset host — stephansmith.me R2 (aligned with content site). */
export const CDN_BASE_URL = 'https://cdn.stephansmith.me';

/** Low Code CTO mark — light backgrounds. */
export const LOW_CODE_LOGO_URL = `${CDN_BASE_URL}/PNG/logo.png`;

/** White mark for dark backgrounds (login, header dark mode). */
export const LOW_CODE_LOGO_DARK_URL = '/images/lowcode-logo-dark.png';
